<template>
  <modal
    name="myStakingPopup"
    :height="modalHeight"
    :clickToClose="closeOutsideWindow"
    adaptive:true
    :width="modalWidth"
  >
    <h1>Stake with Secure Secrets</h1>
    <i class="far fa-window-close fa-2x" @click="hide"></i>
    <div class="modalContent">
      <div class="validator">
        <div class="validator_address">
          {{ secureSecretsAddress }}
        </div>
        <div class="validator_copyButton">
          <i
            class="fas fa-copy fa-1x copyButton"
            @click="textToClipboard(secureSecretsAddress)"
          ></i>
        </div>
      </div>
      <div class="nodeStats">
        <div class="label">Commission Rate:</div>
        <div class="loader" v-show="showLoader1"></div>
        <div class="rate" v-show="!showLoader1">
          {{ commission | convertToPercent }}%
        </div>
        <div class="clipboardAnnouncement" v-show="showClipboardNotification">
          Address copied to clipboard
        </div>
      </div>
      <div class="nodeStats">
        <div class="label">Expected APR:</div>
        <div class="loader" v-show="showLoader2"></div>
        <div class="rate" v-show="!showLoader2">
          {{ returnRate | convertToPercent }}%
        </div>
      </div>
      <button
        class="learnButton"
        onclick="window.open('https://secretnodes.com/secret/chains/secret-2/validators/45521282C12E0EC1691495FCA714947DCA072745','_blank')"
      >
        Learn More
      </button>
    </div>
    <div class="buttons" v-show="!showStakingSection">
      <div class="button StakeButton" @click="showStakingInterface">
        Stake from Keplr Wallet
        <img
          :src="imgUrl(imgObject.imagePath)"
          :alt="imgObject.title"
          height="38px"
        />
      </div>
    </div>
    <transition name="fade">
      <div v-if="showStakingSection">
        <div class="sectionLine"></div>
        <div class="stakingSection">
          <div class="stakingLabel">Keplr Address:</div>
          <div class="personalAddress walletOutput">
            {{ walletAddress }}
          </div>
          <div class="stakingLabel">Available Balance</div>
          <div class="loader" v-show="showLoader3"></div>
          <div class="walletOutput" v-show="!showLoader3">
            <div class="balance">{{ balance }}</div>
            <div class="tokenType">SCRT</div>
          </div>
          <div class="stakingLabel">Amount to Stake</div>
          <div class="stakingInput">
            <input v-model="amountToStake" @focus="$event.target.select()" />
            <div class="tokenType">SCRT</div>
          </div>
          <div class="submitButtonContainer" v-show="!showSubmitLoader">
            <button
              id="toggle"
              class="submitButton"
              @click="stake(amountToStake)"
            >
              Submit
            </button>
            <div class="errorMessage" v-show="showInputError">
              Enter a Valid Number
            </div>
          </div>
          <div class="submitLoaderContainer" v-show="showSubmitLoader">
            <div class="circle-loader">
              <div class="checkmark draw"></div>
            </div>
            <div class="transactionStatus" v-show="transactionSuccessful">
              Transaction Successful!
              <a v-bind:href="transactionHashLink">View Hash.</a>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </modal>
</template>
<script>
import $ from "jquery";
var images = require.context("../assets/", false, /\.svg$|\.jpg$/);

export default {
  props: ["imgObject", "getValidatorParameters", "modalWidth"],

  data: () => ({
    modalHeight: "auto",
    secureSecretsAddress:
      "secretvaloper1rfnmcuwzf3zn7r025j9zr3ncc7mt9ge56l7se7",
    showClipboardNotification: false,
    showStakingSection: false,
    closeOutsideWindow: false,
    commission: 0,
    returnRate: 0,
    balance: 0,
    walletAddress: "",
    keplrOfflineSigner: "",
    account: {},
    amountToStake: 0,
    cosmJS: "",
    showLoader1: true,
    showLoader2: true,
    showLoader3: true,
    showSubmitLoader: false,
    showInputError: false,
    showTEST: false,
    transactionHashLink: "",
    transactionSuccessful: false,
  }),
  filters: {
    convertToPercent: function (input) {
      return Math.round(input * 10000) / 100;
    },
  },
  watch: {
    getValidatorParameters(newVal, oldVal) {
      if (newVal === true) {
        this.getValidatorData();
      }
    },
  },
  methods: {
    hide() {
      this.$modal.hide("myStakingPopup");
      this.showClipboardNotification = false;
      this.showStakingSection = false;
      this.transactionSuccessful = false;
      this.showSubmitLoader = false;
      this.amountToStake = 0;
    },

    async getValidatorData() {
      this.commission = await this.getCommission();
      this.showLoader1 = false;
      this.returnRate = await this.calcROI(this.commission);
      this.showLoader2 = false;
    },

    async getCommission() {
      let response = await fetch(
        process.env.VUE_APP_SECRET_REST_URL + "/staking/validators"
      );
      let responseJson = await response.json();

      for (let i = 0; i < responseJson.result.length; i++) {
        const address = responseJson.result[i].operator_address;
        if (address === this.secureSecretsAddress) {
          return responseJson.result[i].commission.commission_rates.rate;
        }
      }
    },
    async showStakingInterface() {
      this.showStakingSection = true;
      const {
        SigningCosmWasmClient,
        // Secp256k1Pen,
        // makeSignBytes,
      } = require("secretjs");

      if (!window.getOfflineSigner || !window.keplr) {
        alert(
          "Keplr Wallet not detected, please install extension. Learn more at https://keplr.xyz/"
        );
        this.showStakingSection = false;
      } else {
        await window.keplr.enable(process.env.VUE_APP_SECRET_CHAIN_ID);

        this.keplrOfflineSigner = await window.getOfflineSigner(
          process.env.VUE_APP_SECRET_CHAIN_ID
        );
        const accounts = await this.keplrOfflineSigner.getAccounts();

        // import address
        this.walletAddress = accounts[0].address;

        this.cosmJS = new SigningCosmWasmClient(
          // eslint-disable-next-line prettier/prettier
          
          // Production deployment
          process.env.VUE_APP_SECRET_REST_URL,

          // local development
          // 'http://localhost:8080/',

          this.walletAddress,
          this.keplrOfflineSigner,
          window.getEnigmaUtils(process.env.VUE_APP_SECRET_CHAIN_ID),
          {
            init: {
              amount: [{ amount: "300000", denom: "uscrt" }],
              gas: "300000",
            },
            exec: {
              amount: [{ amount: "300000", denom: "uscrt" }],
              gas: "300000",
            },
          }
        );
        this.account = await this.cosmJS.getAccount();
        this.balance = this.getScrt(this.account);
        this.showLoader3 = false;
      }
    },
    stake(amount) {
      // convert human input to on-chain ints

      amount = parseFloat(amount);
      if (this.validateStakingInput(amount) === false) {
        this.showInputError = true;
        return false;
      }
      this.showInputError = false;
      this.showSubmitLoader = true;
      amount *= 1000000;
      amount = Math.floor(amount);

      // send delegation tx
      (async () => {
        // define memo (not required)
        const memo = "Delegation from SecureSecrets.org Site";

        // define msg
        const sendMsg = {
          type: "cosmos-sdk/MsgDelegate",
          value: {
            delegator_address: this.walletAddress,
            validator_address: this.secureSecretsAddress,
            amount: {
              denom: "uscrt",
              amount: amount.toString(),
            },
          },
        };

        // // define fees
        const fee = {
          amount: [
            {
              amount: "50000",
              denom: "uscrt",
            },
          ],
          gas: "270000",
        };

        // sign transaction
        const { accountNumber, sequence } = await this.cosmJS
          .getNonce(this.walletAddress)
          .catch((err) => {
            throw new Error(`Could not get nonce: ${err}`);
          });

        const signedTx = await this.cosmJS
          .signAdapter(
            [sendMsg],
            fee,
            process.env.VUE_APP_SECRET_CHAIN_ID,
            memo,
            accountNumber,
            sequence
          )
          .catch((err) => {
            throw new Error(`Could not sign Tx: ${err}`);
          });

        // broadcast TX
        const result = await this.cosmJS.postTx(signedTx).catch((err) => {
          throw new Error(`Could not post tx: ${err}`);
        });

        if (result.code !== undefined && result.code !== 0) {
          alert("Failed to send tx: " + result.log || result.rawLog);
        } else {
          $(".circle-loader").toggleClass("load-complete");
          $(".checkmark").toggle();
          this.transactionHashLink =
            "https://secretnodes.com/secret/chains/secret-2/transactions/" +
            result.transactionHash;
          this.transactionSuccessful = true;

          this.account = await this.cosmJS.getAccount();
          this.balance = this.getScrt(this.account);
        }
      })();
    },

    imgUrl: function (path) {
      return images("./" + path);
    },
    textToClipboard(text) {
      var dummy = document.createElement("textarea");
      document.body.appendChild(dummy);
      dummy.value = text;
      dummy.select();
      document.execCommand("copy");
      document.body.removeChild(dummy);
      this.showClipboardNotification = true;
    },
    isDenomScrt(balance) {
      return balance.denom === "uscrt";
    },

    getScrt(account) {
      if (account === undefined) {
        return "0 SCRT";
      } else {
        const balance = account.balance.find(this.isDenomScrt);
        let amount = 0;
        if (balance) {
          amount = balance.amount > 0 ? balance.amount / 10 ** 6 : 0;
        }
        return amount;
      }
    },
    validateStakingInput: function (input) {
      if (isNaN(input) === false && input >= 0) {
        return true;
      } else {
        return false;
      }
    },

    // API Queries
    async getInflation() {
      let response = await fetch(
        process.env.VUE_APP_SECRET_REST_URL + "/minting/inflation"
      );
      let responseJson = await response.json();
      return responseJson.result;
    },

    async getTotalSupply() {
      let response = await fetch(
        process.env.VUE_APP_SECRET_REST_URL + "/supply/total"
      );
      let responseJson = await response.json();
      return responseJson.result[0].amount / 1000000;
    },

    async getTotalStaked() {
      let response = await fetch(
        process.env.VUE_APP_SECRET_REST_URL + "/staking/pool"
      );
      let responseJson = await response.json();
      return responseJson.result.bonded_tokens / 1000000;
    },

    async getTaxes() {
      let response = await fetch(
        process.env.VUE_APP_SECRET_REST_URL + "/distribution/parameters"
      );
      let responseJson = await response.json();
      return {
        foundationTax: responseJson.result.secret_foundation_tax,
        communityTax: responseJson.result.community_tax,
      };
    },

    // Calculation
    async calcROI(commission) {
      const inflationRate = await this.getInflation();
      const totalSCRTSupply = await this.getTotalSupply();
      const totalSCRTStaked = await this.getTotalStaked();
      let taxes = await this.getTaxes();
      const foundationTax = taxes.foundationTax;
      const communityTax = taxes.communityTax;

      let ROI =
        (inflationRate / (totalSCRTStaked / totalSCRTSupply)) *
        (1 - foundationTax - communityTax) *
        (1 - commission);
      return ROI;
    },
  },
  imgUrl: function (path) {
    return images("./" + path);
  },
};
</script>
<style lang="scss" scoped>
h1 {
  margin: 18px 0 7px 0;
  text-align: center;
  font-size: 30px;
}

.fa-window-close {
  position: absolute;
  top: 6px;
  left: 560px;
  color: #555;
}
.fa-window-close:hover {
  cursor: pointer;
  color: rgb(160, 159, 159);
}

.modalContent {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  text-align: left;
  margin-left: 30px;
}

.validator {
  margin-top: 10px;
  display: flex;
  font-size: larger;

  .validator_address {
    margin-right: 10px;
    border-style: solid;
    border-color: gray;
    border-width: 2px;
    border-radius: 5px;
    padding: 3px 6px;
    background-color: rgb(228, 228, 228);
    margin-bottom: 5px;
  }
  i {
    margin-top: 6px;
  }
}
.nodeStats {
  display: flex;
}
.label {
  font-size: 20px;
  margin: 5px 0 0 10px;
  font-weight: bold;
  width: 168px;
}
.rate {
  width: 20px;
  font-size: 20px;
  margin: 5px 0 0 0;
  font-weight: bold;
}

.learnButton {
  border-style: solid;
  width: 150px;
  padding: 5px;
  font-size: 20px;
  font-weight: bold;
  margin: 10px 0 20px 10px;
  background-color: white;
  border-radius: 5px;
}
.learnButton:hover {
  background-color: rgb(20, 26, 60);
  color: white;
  cursor: pointer;
}

.buttons {
  display: flex;
  justify-content: center;
}

.button {
  border: none;
  color: white;
  padding: 17px 24px;
  text-decoration: none;
  font-size: 26px;
  margin: 20px 0 25px 0;
  cursor: pointer;
  display: flex;
  align-items: center;

  img {
    margin-left: 10px;
  }
}

.StakeButton {
  background-color: rgb(20, 26, 60);
  border-radius: 12px;
  color: white;
  cursor: pointer;
}

.button:hover {
  background-color: rgb(156, 156, 156);
}

.copyButton:hover {
  cursor: pointer;
}

.clipboardAnnouncement {
  margin: 2px 30px 0 auto;
}

.stakingSection {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 15px 0 20px 40px;
}
.stakingLabel {
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 3px;
}

.walletOutput {
  font-size: 20px;
  display: flex;
  margin-bottom: 10px;
}
.tokenType {
  margin-left: 3px;
  font-size: 20px;
}

.stakingInput {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.submitButton {
  border: none;
  width: 150px;
  padding: 7px;
  font-size: 20px;
  margin-right: 13px;
  font-weight: bold;
  background-color: rgb(20, 26, 60);
  border-radius: 5px;
  color: white;
  margin-top: 3px;
}
.submitButton:hover {
  background-color: rgb(156, 156, 156);
  cursor: pointer;
}

.sectionLine {
  height: 2px;
  background: #555;
}

input {
  width: 150px;
  padding: 3px;
  margin: 0;
  box-sizing: border-box;
  text-align: right;
  font-size: 20px;
}

.submitButtonContainer {
  display: flex;
  align-items: center;
}

.errorMessage {
  color: red;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.loader {
  border: 6px solid #f3f3f3; /* Light grey */
  border-top: 6px solid rgb(20, 26, 60); /* Blue */
  border-radius: 50%;
  width: 15px;
  height: 15px;
  animation: spin 2s linear infinite;
}

.submitLoaderContainer {
  margin-left: 52px;
  display: flex;
  align-items: center;
  a {
    margin-left: 3px;
  }
}

.transactionStatus {
  margin-left: 10px;
  font-size: 18px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@media (max-width: 600px) {
  .fa-window-close {
    left: 460px;
  }

  .validator_address {
    font-size: smaller;
  }
}
@media (max-width: 500px) {
  h1 {
    margin: 6px 40px 0px 40px;
  }
  .learnButton {
    margin-bottom: 10px;
  }
  .button {
    font-size: 22px;
    padding: 10px 10px;
    margin: 0px 0 12px 0;
  }
  .validator_address {
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .modalContent {
    margin-left: 5px;
    margin-right: 13px;
  }
  .stakingSection {
    margin: 10px 0 10px 15px;
  }
  .personalAddress {
    width: 260px;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .fa-window-close {
    left: 261px;
  }
  .clipboardAnnouncement {
    display: none;
  }
}

//loader styling
// Define vars we'll be using
$brand-success: rgb(20, 26, 60);
$loader-size: 2em;
$check-height: $loader-size/2;
$check-width: $check-height/2;
$check-left: ($loader-size/6 + $loader-size/12-0.2);
$check-thickness: 4px;
$check-color: $brand-success;
$success-check-color: green;

.circle-loader {
  margin-bottom: 0;
  border: 4px solid rgba(0, 0, 0, 0.2);
  border-left-color: $check-color;
  animation: loader-spin 1.2s infinite linear;
  position: relative;
  display: inline-block;
  vertical-align: top;
  border-radius: 50%;
  width: $loader-size;
  height: $loader-size;
}

.load-complete {
  -webkit-animation: none;
  animation: none;
  border-color: $success-check-color;
  transition: border 0ms ease-out;
}

.checkmark {
  display: none;

  &.draw:after {
    animation-duration: 800ms;
    animation-timing-function: ease;
    animation-name: checkmark;
    transform: scaleX(-1) rotate(135deg);
  }

  &:after {
    opacity: 1;
    height: $check-height;
    width: $check-width;
    transform-origin: left top;
    border-right: $check-thickness solid $success-check-color;
    border-top: $check-thickness solid $success-check-color;
    content: "";
    left: $check-left;
    top: $check-height;
    position: absolute;
  }
}

@keyframes loader-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes checkmark {
  0% {
    height: 0;
    width: 0;
    opacity: 1;
  }
  20% {
    height: 0;
    width: $check-width;
    opacity: 1;
  }
  40% {
    height: $check-height;
    width: $check-width;
    opacity: 1;
  }
  100% {
    height: $check-height;
    width: $check-width;
    opacity: 1;
  }
}
</style>
